"use strict";

import CriticalValueNotificationConfigForm from "./CriticalValueNotificationConfigForm";
export default CriticalValueNotificationConfigForm;


// WEBPACK FOOTER //
// ./src/view/CriticalValueNotifications/CriticalValueNotificationConfigForm/index.js